/**
 * Pre-upload instruction slides for the passport photo canvas.
 * Each slide pairs a good vs bad visual with a short rule.
 */
export const PASSPORT_PHOTO_INSTRUCTIONS = [
  {
    id: "format",
    title: "Image format",
    message:
      "Photo must be in color. Taken within the last 6 months.",
    goodVariant: "format-good",
    badVariant: "format-bad",
  },
  {
    id: "lighting",
    title: "Lighting",
    message:
      "Use even, natural light on your face. Avoid harsh shadows or backlight.",
    goodVariant: "lighting-good",
    badVariant: "lighting-bad",
  },
  {
    id: "background",
    title: "Background",
    message:
      "Plain, light background works best. No patterns, clutter, or other people.",
    goodVariant: "background-good",
    badVariant: "background-bad",
  },
  {
    id: "expression",
    title: "Expression",
    message:
      "Neutral expression, mouth closed, eyes open and looking at the camera.",
    goodVariant: "expression-good",
    badVariant: "expression-bad",
  },
  {
    id: "head-position",
    title: "Head position",
    message:
      "Face the camera directly. Keep your head level — no tilt or turn.",
    goodVariant: "head-good",
    badVariant: "head-bad",
  },
  {
    id: "accessories",
    title: "Accessories",
    message:
      "No hats, sunglasses, or filters. Prescription glasses are OK if eyes are visible.",
    goodVariant: "accessories-good",
    badVariant: "accessories-bad",
  },
  {
    id: "framing",
    title: "Framing",
    message:
      "Head and shoulders visible. Not too close, not too far — leave space above the head.",
    goodVariant: "framing-good",
    badVariant: "framing-bad",
  },
];

export const PASSPORT_INSTRUCTION_COUNT = PASSPORT_PHOTO_INSTRUCTIONS.length;
